function isLocalhost(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1' || host === '';
}

/**
 * E2E bypass is build-time (VITE_E2E_TEST_MODE) or localStorage on localhost only.
 * Production builds must never ship with VITE_E2E_TEST_MODE=true — deploy-guard
 * greps for the sentinel string if that flag was baked in.
 */
export function isE2ETestMode(): boolean {
  if (import.meta.env.VITE_E2E_TEST_MODE === 'true') {
    if (import.meta.env.PROD) {
      // Unique marker for scripts/deploy-guard.js artifact scan.
      throw new Error(
        'FATAL: __BCI_E2E_MODE_IN_PROD__ — E2E test mode must not ship to sandbox'
      );
    }
    return true;
  }
  return (
    isLocalhost() &&
    typeof window !== 'undefined' &&
    window.localStorage.getItem('E2E_TEST_MODE') === 'true'
  );
}

/**
 * Local-only Support persona — see AGENTS.md for toggle instructions.
 */
export function isE2ESupportUserMode(): boolean {
  if (!isE2ETestMode() || typeof window === 'undefined') {
    return false;
  }
  if (window.localStorage.getItem('E2E_ADMIN_USER') === 'true') {
    return false;
  }
  return window.localStorage.getItem('E2E_SUPPORT_USER') === 'true';
}

/**
 * Local-only Admin persona — enables Monitoring drill-down in dev:local.
 */
export function isE2EAdminUserMode(): boolean {
  if (!isE2ETestMode() || typeof window === 'undefined') {
    return false;
  }
  return window.localStorage.getItem('E2E_ADMIN_USER') === 'true';
}
